import type { SignDocumentApi } from "@/Modules/SignDocuments/Models/Api";
import type {
  CreateTemplateDocumentQueryApi,
  TemplateDocumentApi,
  TemplateDocumentVersionApi,
} from "@/Modules/TemplateDocuments/Models/Api";

import { get2, post2, patch2, remove2 } from "@/Services/TherapyApi/utils/FunctionalTherapyApi";

export const getAllTemplateDocuments = async (): Promise<TemplateDocumentApi[]> => {
  return get2<void, TemplateDocumentApi[]>("v1.0/template_documents");
};

export const createDocumentTemplate = async (
  data: CreateTemplateDocumentQueryApi
): Promise<TemplateDocumentApi> => {
  return post2<CreateTemplateDocumentQueryApi, TemplateDocumentApi>("v1.0/template_documents", data);
};

export const getTemplateDocument = async (uuid: string): Promise<TemplateDocumentApi> => {
  return get2<void, TemplateDocumentApi>(`v1.0/template_documents/${uuid}`);
};

export const publishTemplateDocument = async (uuid: string): Promise<TemplateDocumentApi> => {
  return patch2<void, TemplateDocumentApi>(`v1.0/template_documents/${uuid}`);
};

export const duplicateTemplateDocument = async (uuid: string): Promise<TemplateDocumentApi> => {
  return post2<void, TemplateDocumentApi>(`v1.0/template_documents/${uuid}`);
};

export const removeTemplateDocument = async (uuid: string): Promise<TemplateDocumentApi> => {
  return remove2<void, TemplateDocumentApi>(`v1.0/template_documents/${uuid}`);
};

export const getAllVersions = async (uuid: string): Promise<TemplateDocumentVersionApi[]> => {
  return get2<void, TemplateDocumentVersionApi[]>(`v1.0/template_documents/${uuid}/versions`);
};

export const createVersion = async (
  uuid: string,
  data: Pick<TemplateDocumentVersionApi, "content" | "title">
): Promise<TemplateDocumentApi> => {
  return post2<Pick<TemplateDocumentVersionApi, "content" | "title">, TemplateDocumentApi>(
    `v1.0/template_documents/${uuid}/versions`,
    data
  );
};

export const selectVersion = async (
  templateDocumentId: string,
  versionId: string
): Promise<TemplateDocumentApi> => {
  return post2<void, TemplateDocumentApi>(
    `v1.0/template_documents/${templateDocumentId}/versions/${versionId}`
  );
};

export const sendToSign = async (uuid: string, userUuid: string): Promise<SignDocumentApi> => {
  return post2<void, SignDocumentApi>(`v1.0/template_documents/${uuid}/sign/${userUuid}`);
};

export default {
  getAllTemplateDocuments,
  createDocumentTemplate,
  publishTemplateDocument,
  removeTemplateDocument,
  getAllVersions,
  createVersion,
  selectVersion,
};
